import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http';
import { CacheService, IUnitBusinessBO } from '@mapfre-tech/amap3';
import { map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class BusinessUnitService {

  className = 'BusinessUnitService'

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getAllBusinessUnits(cache = true, cacheKey = "allBusinessUnits"): Observable<IUnitBusinessBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<IUnitBusinessBO[]>;
    } else {
      const observable = this.http.get<IUnitBusinessBO[]>(environment.base_URL + "/units-business").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  getBusinessUnitsByEntity(entity: number[], showDuplicated: boolean | null = null, cache = false, cacheKey = "businessUnitsByEntity"): Observable<IUnitBusinessBO[]> {
    const params: { entityId: string; showDuplicated?: boolean } = { entityId: entity.join(',') };
    if (showDuplicated) {
      params.showDuplicated = showDuplicated;
    }
    if (this.cacheService.canUseCache(cacheKey, [entity.join('_'), showDuplicated ? 'duplicated' : 'uniq']) && cache) {
      return this.cacheService.getCacheData(cacheKey, [entity.join('_'), showDuplicated ? 'duplicated' : 'uniq']) as object as Observable<IUnitBusinessBO[]>;
    } else {
      const observable = this.http.get<IUnitBusinessBO[]>(environment.base_URL + "/units-business", { params }).pipe(map((res) => {
        this.cacheService.updateCacheData(res, cacheKey, [entity.join('_'), showDuplicated ? 'duplicated' : 'uniq'])
        return res;
      }))
      this.cacheService.updateCacheReq(cacheKey, [entity.join('_'), showDuplicated ? 'duplicated' : 'uniq']);
      return observable;
    }
  }

  newBusinessUnit(businessUnit: Omit<IUnitBusinessBO, 'idUnitBusinessPk'>) {
    return this.http.post(environment.base_URL + "/units-business", businessUnit).pipe(tap(() => this.deleteCache()));
  }

  updateBusinessUnit(businessUnit: Omit<IUnitBusinessBO, 'idUnitBusinessPk'>, id: number) {
    return this.http.put(environment.base_URL + `/units-business/${id}`, businessUnit).pipe(tap(() => this.deleteCache()));
  }

  /**
    * Delete Cache
    */

  deleteCache() {
    ["allBusinessUnits", "businessUnitsByEntity"].forEach(item => {
      this.cacheService.deleteCache(item);
    });
  }
}

